import { render, staticRenderFns } from "./CommunitySelector.vue?vue&type=template&id=175a5796&scoped=true"
import script from "./CommunitySelector.vue?vue&type=script&lang=js"
export * from "./CommunitySelector.vue?vue&type=script&lang=js"
import style0 from "./CommunitySelector.vue?vue&type=style&index=0&id=175a5796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175a5796",
  null
  
)

export default component.exports